import React from 'react';

const SuperAdminShieldIcon = (props) => {
  const { size = 40 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="#228053" />
      <g clipPath="url(#clip0_super_admin)">
        <g clipPath="url(#clip1_super_admin)">
          <path
            d="M20.421 12.0911C20.2891 12.0314 20.1477 12 20 12C19.8523 12 19.7109 12.0314 19.5789 12.0911L13.6622 14.6017C12.9709 14.894 12.4556 15.5758 12.4588 16.3991C12.4745 19.5161 13.7565 25.2192 19.1705 27.8115C19.6952 28.0628 20.3048 28.0628 20.8295 27.8115C26.2435 25.2192 27.5255 19.5161 27.5412 16.3991C27.5444 15.5758 27.0291 14.894 26.3378 14.6017L20.421 12.0911ZM23.5507 18.5672L19.5287 22.5892C19.2333 22.8845 18.7557 22.8845 18.4635 22.5892L16.4525 20.5782C16.1571 20.2828 16.1571 19.8052 16.4525 19.513C16.7478 19.2207 17.2254 19.2176 17.5177 19.513L18.9945 20.9898L22.4823 17.4988C22.7777 17.2035 23.2553 17.2035 23.5475 17.4988C23.8397 17.7942 23.8429 18.2718 23.5475 18.564L23.5507 18.5672Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_super_admin">
          <rect width="16" height="16" fill="white" transform="translate(12 12)" />
        </clipPath>
        <clipPath id="clip1_super_admin">
          <rect width="16" height="16" fill="white" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SuperAdminShieldIcon;
